import React, { Component, Fragment } from 'react'
import SidebarMenu from '../../component/sidebar-menu/sidebar-menu.component'
import TopNavigationBar from '../../component/top-navigation-bar/top-navigation-bar.component'
import SendMessageBox from '../../component/send-message-box/send-message-box.component'
import InnerPageContentTitleVideo from '../../component/inner-page-content/inner-page-content-title-video.component'
import InnerPageContentDetails from '../../component/inner-page-content/inner-page-content-details.component'
import Footer from '../../component/footer/footer.component'
import Copyright from '../../component/copyright/copyright.component'

export default class Landing extends Component {
    render() {
        return (
            <Fragment>
                <SidebarMenu/>
                <div className="pusher" id="parentContainer">
                    <TopNavigationBar/>
                    <SendMessageBox/>
                    <InnerPageContentTitleVideo/>
                    <InnerPageContentDetails/>
                    <Footer/>
                    <Copyright/>
                </div>
            </Fragment>        
        )
    }
}
